import { render } from "./HeadingContentComponent.vue?vue&type=template&id=4973b5aa&scoped=true"
import script from "./HeadingContentComponent.vue?vue&type=script&lang=js"
export * from "./HeadingContentComponent.vue?vue&type=script&lang=js"

import "./HeadingContentComponent.vue?vue&type=style&index=0&id=4973b5aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4973b5aa"]])

export default __exports__